import { render, staticRenderFns } from "./ComputeLayoutComponent.vue?vue&type=template&id=5dc82079&lang=pug&"
import script from "./ComputeLayoutComponent.vue?vue&type=script&lang=ts&"
export * from "./ComputeLayoutComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ComputeLayoutComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports